import { render, staticRenderFns } from "./RadioCards.vue?vue&type=template&id=bdf9f3d2&scoped=true"
import script from "./RadioCards.vue?vue&type=script&lang=js"
export * from "./RadioCards.vue?vue&type=script&lang=js"
import style0 from "./RadioCards.vue?vue&type=style&index=0&id=bdf9f3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf9f3d2",
  null
  
)

export default component.exports